import { useState } from 'react'
import { LeadForm, LeadFormValues } from '../../components/form/LeadForm'
import { saveLead, generateLeadId } from '../../services/leads'
import { EVENT } from '../../constants/event'

export function Capture() {
  const [submitCount, setSubmitCount] = useState(0)
  const [savedName, setSavedName] = useState<string | null>(null)

  const handleSubmit = async (values: LeadFormValues) => {
    const now = new Date().toISOString()
    const lead = await saveLead({
      ...values,
      id: generateLeadId(),
      event: EVENT.slug,
      capturedAt: now,
      updatedAt: now,
    })
    console.log('[lead-capture] submit')
    console.log(JSON.stringify(lead, null, 2))
    setSavedName(values.name.trim() || 'friend')
  }

  if (savedName) {
    return (
      <SuccessView
        name={savedName}
        onAgain={() => {
          setSavedName(null)
          setSubmitCount((c) => c + 1)
        }}
      />
    )
  }

  return (
    <LeadForm
      key={submitCount}
      onSubmit={handleSubmit}
      socialsVariant="stacked"
      tcgsVariant="logos"
    />
  )
}

function SuccessView({
  name,
  onAgain,
}: {
  name: string
  onAgain: () => void
}) {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-3 px-8 text-center">
      <div className="text-3xl font-semibold tracking-tight">
        Thanks, {name}!
      </div>
      <div className="text-[15px] leading-snug text-theme-text-subtle">
        You're in. We'll text when there's something new for you.
      </div>
      <button
        type="button"
        onClick={onAgain}
        className="mt-6 rounded-2xl bg-white/[0.05] px-5 py-2.5 text-sm font-medium text-theme-text-subtle ring-1 ring-white/10 transition-colors hover:bg-white/[0.08] hover:text-white"
      >
        Sign up someone else
      </button>
    </div>
  )
}
